import { UserPermissions, Roles } from "@/config/userPermissions";
import store from '@/store';

const getUserOrProviderId = () => {
    let res;

    let isHomeProvider = getIsHomeProvider();
    if (isHomeProvider) {
        let currentProvider: any = store.getters["childcare/getProviderForCurrentUser"];

        if (currentProvider) {
            res = currentProvider.id;
        }
    }
    else {
        let user: any = store.getters["auth/getUser"];

        if (user) {
            if (user.id) {
                res = user.id;
            }
            else if (user.user && user.user.id) {
                res = user.user.id;
            }
        }
    }

    return(res);
}

const getIsHomeProvider = () => {
    let res: boolean = false;

    const currRoleId = UserPermissions.getCurrentRole();
    
    if (currRoleId === Roles.HomeProvider) {
        res = true;
    }
  
    return(res);
}

export {
    getUserOrProviderId,
    getIsHomeProvider
}